import { defaultTo } from '../utils/bits'
import { signUserFunction } from './gallery-properties.flow'

export default signUserFunction(calcModalShowBrandingFooter)

function calcModalShowBrandingFooter(rawVal, calcProp) {
  const features = calcProp('features')
  const canDisableBranding = features.GalleriesBranding
  const modal_show_branding_footer = defaultTo(rawVal, !canDisableBranding)
  return modal_show_branding_footer
}
